import { Box, Button, Collapse, Grid, IconButton } from "@mui/material";
import { SwitchForm } from "components/ui/switchForm";
import { DataMaterias } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  ExpedientesAutorizadosBody,
  getExpedientesAutorizados,
} from "services/expedientesAutorizados/expedientesAutorizadosServices";
import { setIsLoading } from "store";
import {
  setJuzgadosExpedientesAutorizados,
  onDatosBusqueda,
} from "store/serviciosGenerales/generalesSlice";
import Swal from "sweetalert2";
import { AutocompleteMultiForm } from "components/ui/formAutoCompleteMultiple";
import { useEffect, useState } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { listaErrores } from "helpers/helpers";
import CloseIcon from "@mui/icons-material/Close";
import { AutocompleteForm } from "components/ui/autocompleteForm";
import { Region } from "interfaces/demandas/demandasInterface";
import { useIsMounted } from "hooks/useIsMounted";
import { useExpediente } from "hooks/useExpediente";
import { useAppSelector } from "hooks/reduxHooks";
import { useNavigate } from "react-router-dom";
const materias: DataMaterias[] = [
  { cveMateria: 1, descMateria: "CIVIL" },
  { cveMateria: 6, descMateria: "EXTINCIÓN DE DOMINIO" },
  { cveMateria: 2, descMateria: "FAMILIAR" },
  { cveMateria: 8, descMateria: "LABORAL" },
  { cveMateria: 4, descMateria: "MERCANTIL" },
  { cveMateria: 3, descMateria: "PENAL" },
  { cveMateria: -3, descMateria: "PENAL INDÍGENAS" },
];
const regiones = [
  {
    CveRegion: 10,
    NomRegion: "TODAS",
  },
  {
    CveRegion: 1,
    NomRegion: "TOLUCA",
  },
  {
    CveRegion: 2,
    NomRegion: "TLALNEPANTLA",
  },
  {
    CveRegion: 3,
    NomRegion: "TEXCOCO",
  },
  {
    CveRegion: 4,
    NomRegion: "ECATEPEC",
  },
];

export const BusquedaForm = ({}) => {
  const methods = useForm({
    shouldUnregister: true,
  });
  const isMounted = useIsMounted();
  const [alertMessage, setAlertMessage] = useState("");
  const dispatch = useDispatch();
  const {
    setSearch,
    setPenalAdolescente,
    setCveSistemaMateria,
    setResetChecks,
    setLstExpedinetes,
  } = useExpediente();
  const datosBusqueda: any = useAppSelector(
    (state) => state.generales.datosBusqueda
  );
  const navigate = useNavigate();

  //useEffect(()=>{
  // if(datosBusqueda!==null){
  // methods.setValue("cveRegion", datosBusqueda?.region);
  // }
  //},[datosBusqueda]);

  useEffect(() => {
    if (
      isMounted() &&
      (datosBusqueda?.length === 0 || datosBusqueda === null)
    ) {
      methods.setValue("cveRegion", regiones[0]);
      methods.setValue("cveMateria", [materias[0]]);
    } /* eslint-disable-next-line */
  }, [isMounted]);

  const onSubmit = (data: any) => {
    setSearch(true);
    if (!data.cveMateria?.length || !data.cveMateria) {
      Swal.fire({
        title: "Error",
        text: "Debe seleccionar una materia",
        icon: "error",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#801313",
      });

      return;
    }
    const cveRegion = data?.cveRegion?.CveRegion;
    dispatch(setIsLoading(true));
    const body: ExpedientesAutorizadosBody = {
      cveMateria: data.cveMateria?.map(
        (pMateria: DataMaterias) => pMateria.cveMateria
      ),
    };

    if (data.cveMateria?.[0]?.cveMateria === 3) {
      body.adolescentes = data.adolescentes ? "S" : "N";
      setPenalAdolescente(data.adolescentes ? "S" : "N");
      setCveSistemaMateria(data.adolescentes ? 43 : 38);
    } else if ([4, 2, 1, 6, -3].includes(data.cveMateria?.[0]?.cveMateria)) {
      setCveSistemaMateria(30);
    } else if (data.cveMateria?.[0]?.cveMateria === 8) {
      setCveSistemaMateria(68);
    }
    if (
      (data.cveMateria?.[0]?.cveMateria === 3 ||
        data.cveMateria?.[0]?.cveMateria === 8) &&
      cveRegion !== 10
    ) {
      body.cveRegion = cveRegion;
    }
    const search = {
      materias: data.cveMateria,
      region: data?.cveRegion,
    };
    setResetChecks(true);
    setLstExpedinetes([]);
    getExpedientesAutorizados(body)
      .then((juzgadosExpedientes) => {
        dispatch(setJuzgadosExpedientesAutorizados([]));
        dispatch(onDatosBusqueda(search));
        dispatch(setIsLoading(false));
        const lstResponse = juzgadosExpedientes?.[0]?.CveRegion
          ? cveRegion !== 10
            ? juzgadosExpedientes.filter((pExp) => pExp.CveRegion === cveRegion)
            : juzgadosExpedientes
          : juzgadosExpedientes;

        if (lstResponse?.length > 0) {
          const lstExp = lstResponse.flatMap((pJuzgado) =>
            pJuzgado.expedientes.map((pExp) => ({
              ...pExp,
            }))
          );
          setLstExpedinetes(lstExp);
        }
        if (!lstResponse?.length) {
          Swal.fire({
            title: `Advertencia`,
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#6e7881",
            html: `
            <style>
            h4, h5{
              font-family: arial;
              color: #545454;
            }
            </style>
            <h4>No se pudo localizar información con los parámetros proporcionados</h4>`,
          });
        }
        setTimeout(() => {
          dispatch(setJuzgadosExpedientesAutorizados(lstResponse));
          navigate("/dashboard/expediente-electronico");
        }, 250);
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Advertencia`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${err?.response?.data?.data || "Hubo un problema"}</h4>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };
  const handleMateriasChange = (selectedValue: any) => {
    const selectedCveMaterias = selectedValue.map(
      (materia: DataMaterias) => materia.cveMateria
    );
    const restrictedValues1 = [1, 2, 4, 6];
    const restrictedValues2 = [3, 8, -3];

    if (
      (restrictedValues1.some((value) => selectedCveMaterias.includes(value)) &&
        restrictedValues2.some((value) =>
          selectedCveMaterias.includes(value)
        )) ||
      (selectedCveMaterias.includes(3) && selectedCveMaterias.length > 1) ||
      (selectedCveMaterias.includes(8) && selectedCveMaterias.length > 1)
    ) {
      let lstValids = methods.watch("cveMateria");
      let lastUpdate = selectedValue?.[selectedValue?.length - 1];
      let newLSt = lstValids?.filter(
        (pMateria: DataMaterias) =>
          pMateria.cveMateria !== lastUpdate?.cveMateria
      );
      methods.setValue("cveMateria", newLSt);
      setAlertMessage("No puedes seleccionar estas materias juntas");
      return;
    }

    setAlertMessage("");
  };

  return (
    <Box className="w-full">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid item xs={4}>
            <div className="m-2 mx-8 items-center">
              <AutocompleteMultiForm
                name="cveMateria"
                label="Materia"
                descValue="descMateria"
                options={materias?.filter(
                  (item) =>
                    !methods
                      ?.watch("cveMateria")
                      ?.some(
                        (selectedItem: DataMaterias) =>
                          selectedItem?.cveMateria === item?.cveMateria
                      )
                )}
                handleChangeAutoComplete={handleMateriasChange}
              />
            </div>
            {methods.watch("cveMateria")?.[0]?.cveMateria === 3 ? (
              <div className="text-center">
                <Grid>
                  <label className="text-xs mx-1">
                    JUZGADOS ESPECIALIZADOS EN EL SISTEMA INTEGRAL
                  </label>
                </Grid>
                <Grid>
                  <label className="text-xs mt-1">
                    DE JUSTICIA PENAL PARA ADOLESCENTES
                  </label>
                  <SwitchForm name="adolescentes" />
                </Grid>
              </div>
            ) : null}
            <Collapse in={alertMessage ? true : false}>
              {alertMessage && (
                <Alert
                  severity="warning"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setAlertMessage("");
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  <AlertTitle>Cuidado</AlertTitle>
                  {alertMessage}
                </Alert>
              )}
            </Collapse>
          </Grid>
          <Grid item xs={4}>
            <div className="m-2 mx-8 items-center">
              <AutocompleteForm
                name="cveRegion"
                size="small"
                label="Región"
                className="w-full"
                options={regiones}
                loadingText="Cargando información ..."
                rules={{
                  required: {
                    value: true,
                    message: "Selecciona una región",
                  },
                }}
                isOptionEqualToValue={(option: Region, value: Region) =>
                  option.CveRegion === value.CveRegion
                }
                getOptionLabel={(option: Region) => option.NomRegion}
              />
            </div>
          </Grid>
          <Grid item xs={2}>
            <div className="text-center" style={{ zoom: "90%" }}>
              <Button variant="contained" type="submit" color="error">
                Buscar
              </Button>
            </div>
          </Grid>
        </form>
      </FormProvider>
    </Box>
  );
};
